import { Injectable } from "@angular/core";
import { UserService } from "@app/core/services";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";
import { GetUserList, UserListStateModel } from "./index";

@State<UserListStateModel>({
    name: 'Users',
    defaults: {
        users: {},
        activePage: 1,
        filterResult: {}
    }
})

@Injectable()
export class UsersListState {

    constructor(private userService: UserService) {}

    @Selector()
    static getUserList(state: UserListStateModel) {
        return state.users;
    }

    @Selector()
    static getActivePageNumber(state: UserListStateModel) {
        return state.activePage;
    }

    @Selector()
    static getFilterResult(state: UserListStateModel) {
        return state.filterResult;
    }

    @Action(GetUserList)
    getUsersList({getState, setState}: StateContext<UserListStateModel>, { pageIdex, filterResult }: GetUserList) {
        return this.userService.allusers(pageIdex, filterResult).pipe(tap((res: any) => {
            
            const state = getState;
            setState({
                ...state,
                users: res['data']['users'],
                activePage: pageIdex,
                filterResult: filterResult
            })
        }))
    }
}